"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersion2toVersion3 = void 0;
const updateVersion2toVersion3 = (configuration) => {
    return Object.assign(Object.assign({}, configuration), { version: 3, main: Object.assign(Object.assign({}, configuration.main), { playerConfiguration: Object.assign(Object.assign({}, configuration.main.playerConfiguration), { logoOverlay: {
                    url: "",
                    platformId: "",
                    displayLogo: false
                }, aspectRatio: "horizontal" }), surveyConfiguration: {
                surveyId: "",
                backgroundColor: "",
                showAt: 0.9
            } }) });
};
exports.updateVersion2toVersion3 = updateVersion2toVersion3;
//# sourceMappingURL=v3.js.map